export default __webpack_public_path__ + "static/media/Landing-P7-P19-CIFOR.be2bcbfa.jpg";